import React from 'react';

function Step9({ formData, errors, onFileChange, removeFile }) {
  // Función auxiliar para resetear el input y permitir subir el mismo archivo consecutivamente
  const resetInputValue = (e) => {
    e.target.value = '';
  };

  return (
    <div className="step-panel">
      <p className="step-description">
        Por favor adjunte los siguientes documentos en formato <strong>PDF</strong>.
      </p>

      {/* DOCUMENTO DE IDENTIDAD (OBLIGATORIO) */}
      <div className="field-group">
        <label htmlFor="documentoIdentidadFile">
          Fotocopia del documento de identidad del trabajador ampliada al 150% y legible <span className="required">*</span>
        </label>
        <div className="file-input-wrapper">
          <input
            id="documentoIdentidadFile"
            name="documentoIdentidadFile"
            type="file"
            accept=".pdf"
            onChange={onFileChange}
            className={errors.documentoIdentidadFile ? 'error-field' : ''}
          />
        </div>
        {formData.documentoIdentidadFile && (
          <small className="file-loaded-status">✅ Archivo cargado: <strong>{formData.documentoIdentidadFile.name}</strong></small>
        )}
        {errors.documentoIdentidadFile && <span className="field-error">{errors.documentoIdentidadFile}</span>}
        <small className="text-muted">
          Formato permitido: PDF. Tamaño máximo: 500 KB.
        </small>
      </div>

      {/* CERTIFICADO DE PENSIONES (OPCIONAL) */}
      <div className="field-group">
        <label htmlFor="certificadoPensionesFile">
          Certificado de Pensiones
        </label>
        <div className="file-input-wrapper">
          <input
            id="certificadoPensionesFile"
            name="certificadoPensionesFile"
            type="file"
            accept=".pdf"
            onChange={onFileChange}
            className=""
          />
        </div>
        {formData.certificadoPensionesFile && (
          <small className="file-loaded-status">✅ Archivo cargado: <strong>{formData.certificadoPensionesFile.name}</strong></small>
        )}
      </div>

      {/* CERTIFICADO DE EPS (OPCIONAL) */}
      <div className="field-group">
        <label htmlFor="certificadoEpsFile">
          Certificado de EPS
        </label>
        <div className="file-input-wrapper">
          <input
            id="certificadoEpsFile"
            name="certificadoEpsFile"
            type="file"
            accept=".pdf"
            onChange={onFileChange}
            className=""
          />
        </div>
        {formData.certificadoEpsFile && (
          <small className="file-loaded-status">✅ Archivo cargado: <strong>{formData.certificadoEpsFile.name}</strong></small>
        )}
      </div>

      {/* CERTIFICACIÓN BANCARIA (OBLIGATORIO) */}
      <div className="field-group">
        <label htmlFor="certificacionBancariaFile">
          Certificación bancaria actualizada con máximo 2 meses de vigencia, legible <span className="required">*</span>
        </label>
        <div className="file-input-wrapper">
          <input
            id="certificacionBancariaFile"
            name="certificacionBancariaFile"
            type="file"
            accept=".pdf"
            onChange={onFileChange}
            className={errors.certificacionBancariaFile ? 'error-field' : ''}
          />
        </div>
        {formData.certificacionBancariaFile && (
          <small className="file-loaded-status">✅ Archivo cargado: <strong>{formData.certificacionBancariaFile.name}</strong></small>
        )}
        {errors.certificacionBancariaFile && <span className="field-error">{errors.certificacionBancariaFile}</span>}
      </div>

      {/* HOJA DE VIDA (OPCIONAL) */}
      <div className="field-group">
        <label htmlFor="hojaVidaFile">
          Hoja de vida actualizada 
        </label>
        <div className="file-input-wrapper">
          <input
            id="hojaVidaFile"
            name="hojaVidaFile"
            type="file"
            accept=".pdf"
            onChange={onFileChange}
            className=""
          />
        </div>
        {formData.hojaVidaFile && (
          <small className="file-loaded-status">✅ Archivo cargado: <strong>{formData.hojaVidaFile.name}</strong></small>
        )}
        
      </div>

      {formData.incluirBeneficiarios === 'SI' && (
        <div className="beneficiarios-docs-section">
          <h3>Documentación de Beneficiarios Obligatoria</h3>

          {/* A. Documentos de identidad de los beneficiarios */}
          <div className="campo-contenedor">
            <label className="campo-titulo" htmlFor="documentosBeneficiariosFile">
              Fotocopia de los documentos de identidad de cada uno de los beneficiarios ampliada al 150% (CÓNYUGE, HIJOS, HIJASTROS, PADRES y otros) <span className="required">*</span>
            </label>
            <p className="campo-descripcion" style={{ fontWeight: 'bold', color: '#0056b3' }}>
              👉 Agregar en este campo todos los documentos de identidad, uno a uno.
            </p>
            <span className="campo-nota">
              <strong>Nota:</strong> Tarjeta de identidad de los hijos (si la tienen) de igual manera registro civil para comprobar parentesco.
            </span>
            <div className="file-input-wrapper">
              <input
                id="documentosBeneficiariosFile"
                name="documentosBeneficiariosFile"
                type="file"
                accept=".pdf"
                multiple
                onClick={resetInputValue}
                onChange={onFileChange}
                className={errors.documentosBeneficiariosFile ? 'error-field' : ''}
              />
            </div>
            {formData.documentosBeneficiariosFile && formData.documentosBeneficiariosFile.length > 0 && (
              <div className="files-list-container">
                <small className="file-loaded-status">✅ {formData.documentosBeneficiariosFile.length} archivo(s) seleccionado(s):</small>
                <ul className="files-summary-list">
                  {Array.from(formData.documentosBeneficiariosFile).map((file, idx) => (
                    <li key={idx} className="file-item-row">
                      <span>{file.name}</span>
                      <button 
                        type="button" 
                        className="btn-remove-file" 
                        onClick={() => removeFile('documentosBeneficiariosFile', idx)}
                        title="Eliminar este archivo"
                      >
                        ×
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {errors.documentosBeneficiariosFile && <span className="field-error">{errors.documentosBeneficiariosFile}</span>}
          </div>

          {/* B. Afiliación de Padres */}
          <div className="campo-contenedor">
            <label className="campo-titulo" htmlFor="documentosPadresFile">
              En caso de afiliación de los Padres
            </label>
            <p className="campo-descripcion">Adjunte fotocopia del registro civil de nacimiento del trabajador y certificado de EPS de padre/madre.</p>
            <div className="file-input-wrapper">
              <input
                id="documentosPadresFile"
                name="documentosPadresFile"
                type="file"
                accept=".pdf"
                multiple
                onClick={resetInputValue}
                onChange={onFileChange}
                className=""
              />
            </div>
            {formData.documentosPadresFile && formData.documentosPadresFile.length > 0 && (
              <div className="files-list-container">
                <small className="file-loaded-status">✅ {formData.documentosPadresFile.length} archivo(s) seleccionado(s):</small>
                <ul className="files-summary-list">
                  {Array.from(formData.documentosPadresFile).map((file, idx) => (
                    <li key={idx} className="file-item-row">
                      <span>{file.name}</span>
                      <button 
                        type="button" 
                        className="btn-remove-file" 
                        onClick={() => removeFile('documentosPadresFile', idx)}
                      >
                        ×
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* C. Certificado de estudio para hijos mayores de 12 años */}
          <div className="campo-contenedor">
            <label className="campo-titulo" htmlFor="certificadoEstudioFile">
              Para los hijos a partir de los 12 años
            </label>
            <p className="campo-descripcion">Se necesita certificado de estudio original, actual y legible.</p>
            <div className="file-input-wrapper">
              <input
                id="certificadoEstudioFile"
                name="certificadoEstudioFile"
                type="file"
                accept=".pdf"
                multiple
                onClick={resetInputValue}
                onChange={onFileChange}
                className=""
              />
            </div>
            {formData.certificadoEstudioFile && formData.certificadoEstudioFile.length > 0 && (
              <div className="files-list-container">
                <small className="file-loaded-status">✅ {formData.certificadoEstudioFile.length} archivo(s) seleccionado(s):</small>
                <ul className="files-summary-list">
                  {Array.from(formData.certificadoEstudioFile).map((file, idx) => (
                    <li key={idx} className="file-item-row">
                      <span>{file.name}</span>
                      <button 
                        type="button" 
                        className="btn-remove-file" 
                        onClick={() => removeFile('certificadoEstudioFile', idx)}
                      >
                        ×
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* D. Registro Civil de Matrimonio */}
          <div className="campo-contenedor">
            <label className="campo-titulo" htmlFor="registroMatrimonioFile">
              En caso de estar CASADO(A)
            </label>
            <p className="campo-descripcion">Adjuntar el documento Registro Civil de matrimonio.</p>
            <div className="file-input-wrapper">
              <input
                id="registroMatrimonioFile"
                name="registroMatrimonioFile"
                type="file"
                accept=".pdf"
                onChange={onFileChange}
                className=""
              />
            </div>
            {formData.registroMatrimonioFile && (
              <small className="file-loaded-status">✅ Archivo cargado: <strong>{formData.registroMatrimonioFile.name}</strong></small>
            )}
          </div>

          {/* E. Declaración de Unión Libre */}
          <div className="campo-contenedor">
            <label className="campo-titulo" htmlFor="declaracionUnionLibreFile">
              En caso de UNIÓN LIBRE
            </label>
            <p className="campo-descripcion">Documento declaración bajo juramento fines extraproceso.</p>
            <span className="campo-nota">
              <strong>Nota:</strong> El documento no debe tener más de 6 meses de expedición.
            </span>
            <div className="file-input-wrapper">
              <input
                id="declaracionUnionLibreFile"
                name="declaracionUnionLibreFile"
                type="file"
                accept=".pdf"
                onChange={onFileChange}
                className=""
              />
            </div>
            {formData.declaracionUnionLibreFile && (
              <small className="file-loaded-status">✅ Archivo cargado: <strong>{formData.declaracionUnionLibreFile.name}</strong></small>
            )}
          </div>

          {/* F. Formato Declaración Juramentada de Mintrabajo */}
          {(formData.afiliara === 'caja de compensacion' || formData.afiliara === 'ambas') && (
            <div className="campo-contenedor">
              <label className="campo-titulo" htmlFor="formatoMintrabajoFile">
                Declaración Juramentada del Ministerio de Trabajo <span className="required">*</span>
              </label>
              <p className="campo-descripcion">
                Para afiliación a Caja de Compensación de padres, hijastros, cónyuge, y otros. Reemplaza la declaración juramentada por notaría.
              </p>
              <div className="file-input-wrapper">
                <input
                  id="formatoMintrabajoFile"
                  name="formatoMintrabajoFile"
                  type="file"
                  accept=".pdf"
                  multiple
                  onChange={onFileChange}
                  className={errors.formatoMintrabajoFile ? 'error-field' : ''}
                />
              </div>
            {formData.formatoMintrabajoFile && formData.formatoMintrabajoFile.length > 0 && (
              <div className="files-list-container">
                <small className="file-loaded-status">✅ {formData.formatoMintrabajoFile.length} archivo(s) seleccionado(s):</small>
                <ul className="files-summary-list">
                  {Array.from(formData.formatoMintrabajoFile).map((file, idx) => (
                    <li key={idx} className="file-item-row">
                      <span>{file.name}</span>
                      <button 
                        type="button" 
                        className="btn-remove-file" 
                        onClick={() => removeFile('formatoMintrabajoFile', idx)}
                        title="Eliminar este archivo"
                      >
                        ×
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {errors.formatoMintrabajoFile && <span className="field-error">{errors.formatoMintrabajoFile}</span>}
          </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Step9;